import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import NeonHeader from 'components/bolt/neonHeader/neonHeader.js';

export default class Header extends BaseComp.default {

	render() {
		const baseJSX = super.render(this.props);
		return (
			<div>
				<NeonHeader />
				{baseJSX}
			</div>
		);
	}
}
